import { useLingui } from "@lingui/react/macro";
import { Minimize } from "lucide-react";
import { useContext } from "react";
import { desktopBridge, windowChromeKind } from "../lib/desktop";
import { useDesktopImmersive } from "../lib/use-desktop-immersive";
import { WorkspaceWindowIdContext } from "../lib/workspace-local-state";

export function WindowChrome() {
  const { t } = useLingui();
  const desktop = desktopBridge();
  const immersive = useDesktopImmersive();
  const workspaceWindow = useContext(WorkspaceWindowIdContext);
  if (workspaceWindow) return null;
  if (immersive.enabled)
    return (
      <button
        type="button"
        data-window-chrome
        className="app-no-drag flex items-center gap-1 rounded-md px-2 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground"
        aria-label={t`Exit Immersive Mode`}
        title={t`Exit Immersive Mode (Control + Option + Escape)`}
        onClick={() => void immersive.set(false)}
      >
        <Minimize size={14} />
        <span>{t`Exit`}</span>
      </button>
    );
  const kind = windowChromeKind(desktop);
  if (kind === "spacer") {
    return <div data-window-chrome className="h-3 w-[72px]" aria-hidden="true" />;
  }
  if (kind === "darwin") {
    return <div data-window-chrome className="app-drag h-3 w-[72px]" aria-hidden="true" />;
  }
  return (
    <div data-window-chrome className="app-drag flex gap-[7px]">
      <button
        type="button"
        className="app-no-drag h-3 w-3 rounded-full bg-[#FF5F57]"
        aria-label={t`Close`}
        onClick={() => void desktop?.window.close()}
      />
      <button
        type="button"
        className="app-no-drag h-3 w-3 rounded-full bg-[#FEBC2E]"
        aria-label={t`Minimize`}
        onClick={() => void desktop?.window.minimize()}
      />
      <button
        type="button"
        className="app-no-drag h-3 w-3 rounded-full bg-[#28C840]"
        aria-label={t`Fullscreen`}
        onClick={() => void desktop?.window.toggleMaximize()}
      />
    </div>
  );
}
